<template>
  <div id="app">    
    <!-- Aquí se renderizarán los componentes de las rutas -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>

</style>
